import { ISubscription } from "@/services/SubscriptionService";
import { amountToHeight, formatAmount } from "../util";
import { ThemeContext } from "@fluentui/react-theme-provider";
import { useContext } from "react";

type TPlansChartProps =
{
    subscriptions?: ISubscription[];
    selectedPlan?: ISubscription;
    onPlanClick: (planId: number) => void;
};

const BASE_CLASS = "plansChart"

const PlansChart = ({subscriptions, selectedPlan, onPlanClick}: TPlansChartProps) =>
{
    const theme: any = useContext(ThemeContext);
    if(!subscriptions || subscriptions.length === 0)
    {
        return <></>;
    }

    return(
        <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}__verticalTextWrapper ${theme && theme.name === "dark" ? `${BASE_CLASS}__coloredWhite` : ""}`}>
                <div className={`${BASE_CLASS}__verticalText`}>Valor cartera</div>
            </div>
            <div className={`${BASE_CLASS}__horizontalTextWrapper ${theme && theme.name === "dark" ? `${BASE_CLASS}__coloredWhite` : ""}`}>
                <div className={`${BASE_CLASS}__plotArea ${theme && theme.name === "dark" ? `${BASE_CLASS}__coloredWhite` : ""}`}>
                    <div className={`${BASE_CLASS}__barsRow`}>
                        {subscriptions.map((plan: ISubscription) =>
                        {
                            const selected = plan.id === selectedPlan?.id;

                            return(
                                <div key={plan.id} className={`${BASE_CLASS}__barCol`}>
                                    <div className={`${BASE_CLASS}__bar`}
                                        style={
                                        {
                                            height: amountToHeight(plan.limit ? plan.limit : 4_000_000),
                                            background: selected ? "#CC214F" : "#111",
                                            boxShadow: selected ? "0 -4px 10px rgba(204,0,0,.4)" : "none"
                                        }}
                                        onClick={() =>
                                        {
                                            plan.id && onPlanClick(plan.id)
                                        }}
                                    >
                                        <div className={`${BASE_CLASS}__barLabel`}>
                                            <p className={`${BASE_CLASS}__barLabelName`}>{plan.name}</p>
                                            <p>{plan.limit ? "Límite" : "Sin límite"}</p>
                                            <p>{plan.limit ? `${formatAmount(plan.limit)}` : ""}</p>
                                        </div>

                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={`${BASE_CLASS}__horizontalText`}>Suscripciones</div>
            </div>
        </div>
    );
}

export default PlansChart;